import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AttendanceService } from '../../services/attendance.service';
import { SalaryPaymentDto } from '../../interfaces/interfaces';

@Component({
  selector: 'app-salary-payment-dialog',
  templateUrl: './salary-payment-dialog.component.html',
  styleUrls: ['./salary-payment-dialog.component.scss']
})
export class SalaryPaymentDialogComponent {
  paymentForm: FormGroup;
  loading = false;

  statusOptions = [
    { value: 1, label: 'Pending' },
    { value: 2, label: 'Paid' },
    { value: 3, label: 'Overdue' }
  ];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<SalaryPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private attendanceService: AttendanceService
  ) {
    this.paymentForm = this.fb.group({
      employeeId: [data.employeeId, Validators.required],
      year: [data.year, Validators.required],
      month: [data.month, Validators.required],
      amount: [Number(data.totalAmount).toFixed(2), Validators.required],
      hoursWorked: [Number(data.hoursWorked).toFixed(2)],
      daysWorked: [data.daysWorked],
      status: [1, Validators.required],
      paymentDate: [new Date(), Validators.required],
      paymentMethod: ['BACS', Validators.required],
      referenceNumber: [''],
      notes: ['']
    });
  }

  onSubmit() {
    if (this.paymentForm.invalid) return;
    this.loading = true;
    const dto: SalaryPaymentDto = {
      ...this.paymentForm.value,
      amount: Number(Number(this.paymentForm.value.amount).toFixed(2)),
      hoursWorked: Number(Number(this.paymentForm.value.hoursWorked).toFixed(2))
    };
    this.attendanceService.createSalaryPayment(dto).subscribe({
      next: (res) => {
        this.loading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.loading = false;
        alert('Failed to save payment: ' + (err.error?.message || err.message));
      }
    });
  }

  onCancel() {
    this.dialogRef.close(false);
  }
} 